import { render, staticRenderFns } from "./three.vue?vue&type=template&id=3df35c1a&scoped=true"
import script from "./three.vue?vue&type=script&lang=ts"
export * from "./three.vue?vue&type=script&lang=ts"
import style0 from "./three.vue?vue&type=style&index=0&id=3df35c1a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3df35c1a",
  null
  
)

export default component.exports